import React, { useEffect, useState } from "react";
// mui
import { Grid2 } from "@mui/material";
//styling
import styles from "./FileExplorer.module.scss";
// local import
import SiteHeaderCard from "../../Components/HeaderComponent/Header";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import getAuthorizationHeader, {
  adminApi,
  formatFileSizeCaps,
  lastSegmentPath,
  STAGING,
} from "../../../../../../Utils/roconConstants";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {
  getStagingEnv,
  siteDetails,
  staging,
} from "../../../../../../Utils/sitePages";
import FileTable from "./Components/FileTable";
import UploadPopup from "./Components/UploadPopup";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { formatUsTimestamp } from "../../../../../../Utils/utils";

export default function FileExplorer() {
  const [uploadPopup, setUploadPopup] = useState(false);
  const [pathAttributes, setPathAttributes] = useState(null);
  const [close, setClose] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState({
    folderName: "",
    fileName: "",
  });
  const dispatch = useDispatch();
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });
  const [value, setValue] = useState(0);

  const [loading, setLoading] = useState(false);

  let sites = useSelector((state) => state?.sitesInfo?.selectedSite);

  let path = useSelector(
    (state) => state.sitesInfo?.selectedSite?.fileExplorerLocation,
  );

  let organizationsInfo = useSelector(
    (state) => state.organizationsInfo.selectedOrg,
  );

  let userDetails = useSelector((state) => state.users.userDetails?.country);

  let uploadDetails = useSelector((state) => state.sitesInfo?.uploadDetails);
  const uploadProgress = useSelector((state) => state.sitesInfo?.uploadProgress);
  const params = useParams();
  const orgId = params.orgId;
  const siteId = params.siteId;
  const isStaging = staging(sites);
  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  const siteData = siteDetails(sites);
  let livedom = siteData?.domain.find((item) => item.primary === "Y")?.name;
  const selectedDomain = useSelector((state) => state.sitesInfo.selectedDomain);

  useEffect(() => {
    if (!sites)
      getStore().dispatch({
        type: Actions.API_GET_SELECTED_SITE_DETAILS,
        data: { siteId: siteId },
        meta: {
          onSuccess: (data) => {
            const selectedEnvData = data.stagingDomainsList.find(
              (list) =>
                list.environment ===
                (selectedDomain?.environment === "STAGING"
                  ? "STAGING"
                  : "LIVE"),
            );
            getStore().dispatch({
              type: Actions.SET_SELECTED_DOMAIN,
              data: selectedEnvData,
            });
          },
          onError: () => {},
        },
      });
  }, [sites, selectedDomain?.environment]);

  // Re-fetch files if they get wiped by SET_SELECTED_SITE_DETAILS (e.g. after visiting Dev Tools)
  useEffect(() => {
    if (sites && !sites.files) {
      getStore().dispatch({
        type: Actions.API_GET_SITE_FILES,
        data: {
          siteId: siteId,
          path: "/",
          stagingDomainName:
            selectedDomain?.environment === "STAGING"
              ? selectedDomain.domainName
              : sites?.siteName,
        },
      });
    }
  }, [sites, siteId, selectedDomain?.environment]);

  useEffect(() => {
    if (!sites) {
      getStore().dispatch({
        type: Actions.API_GET_SELECTED_SITE_DETAILS,
        data: { siteId: siteId },
        meta: {
          onSuccess: (data) => {
            let sitename = data?.siteName;
            let path = "/";

            getStore().dispatch({
              type: Actions.API_GET_SITE_FILES,
              data: {
                siteId: siteId,
                path: path,
                stagingDomainName:
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : sitename,
              },
            });

            getStore().dispatch({
              type: Actions.SET_SITE_DETAILS,
              data: {
                orgId: orgId,
                siteId: siteId,
                sitePage: lastSegment,
              },
            });

            const selectedEnvData = data.stagingDomainsList.find(
              (list) =>
                list.environment ===
                (selectedDomain?.environment === "STAGING"
                  ? "STAGING"
                  : "LIVE"),
            );
            getStore().dispatch({
              type: Actions.SET_SELECTED_DOMAIN,
              data: selectedEnvData,
            });
          },
          onError: () => {},
        },
      });
    } else {
      let path = "/";

      getStore().dispatch({
        type: Actions.API_GET_SITE_FILES,
        data: {
          siteId: siteId,
          path: path,
          stagingDomainName:
            selectedDomain?.environment === "STAGING"
              ? selectedDomain.domainName
              : sites?.siteName,
        },
      });

      getStore().dispatch({
        type: Actions.SET_SITE_DETAILS,
        data: {
          orgId: orgId,
          siteId: siteId,
          sitePage: lastSegment,
        },
      });
    }
  }, [siteId, selectedDomain?.environment]);

  const handleSelected = (folderName) => {
    if (folderName) {
      openFolder(folderName);
    }
  };

  const openFolder = (folderName) => {
    let pathLocation = "/";
    if (folderName !== "/") {
      pathLocation = (path ? path : "/") + folderName + "/";
    }
    const stagingDomainName = siteData?.siteName;
    getStore().dispatch({
      type: Actions.API_GET_SITE_FILES,
      data: {
        siteId: siteData?.siteId,
        path: pathLocation.toString(),
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : stagingDomainName,
      },
      meta: {
        onSuccess: () => {
          if (folderName !== "/") {
            const parts = path ? path.split("/") : [];
            parts.push(folderName);

            setPathAttributes(parts.filter((item) => item !== ""));
          } else {
            setPathAttributes([]);
          }
        },
        onError: () => {
          const parts = path.split("/");
          setPathAttributes(parts);
        },
      },
    });
  };

  const openPath = (index) => {
    let str = "/";
    let temp = [];
    for (let i = 0; i <= index; i++) {
      if (pathAttributes[i] !== "") {
        str = str + pathAttributes[i] + "/";
        temp.push(pathAttributes[i]);
      }
    }
    setLoading(true);
    let stagingDomainName = siteData?.siteName;
    getStore().dispatch({
      type: Actions.API_GET_SITE_FILES,
      data: {
        siteId: siteData?.siteId,
        path: str,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : stagingDomainName,
      },
      meta: {
        onSuccess: () => {
          setLoading(false);
          setPathAttributes(temp);
        },
        onError: () => {
          setLoading(false);
        },
      },
    });
  };

  const setUploadDetails = (data) => {
    const uploadDetailsTemp = uploadDetails ? uploadDetails : {};
    getStore().dispatch({
      type: Actions.SET_FILE_UPLOAD_DETAILS,
      data: {
        ...uploadDetailsTemp,
        ...data,
      },
    });
  };

  const flushStateVariables = () => {
    setUploadPopup(false);
    setUploadDetails({ filesSelected: [], uploadingStatus: undefined });
    setLoading(false);
    setValue(0);
    setClose(false);
  };

  const ActivatePopup = (type, fileName) => {
    if (type === "confirm-deletefile") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: `Delete File "${fileName}"?`,
        popupSubtitle:
          "Are you sure you want to delete this file? This action cannot be undone.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          // Swap the confirm dialog for the "Deleting…" loader; delFileAPI's
          // onSuccess/onError transitions it to the success/error state.
          ActivatePopup("loading-del");
          delFileAPI(fileName);
        },
      });
    } else if (type === "loading-del") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Deleting File...",
        popupSubtitle:
          "Your file deletion is in progress. Please wait a moment.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "success-del") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "File Deleted",
        popupSubtitle: "Your file has been deleted successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "loading") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Downloading File",
        popupSubtitle: "Your download is in progress. Please wait a moment.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Download Successful!",
        popupSubtitle: "Your file has been downloaded successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Oops! something went wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  // Number of parallel upload workers.
  const MAX_CONCURRENT_UPLOADS = 10;

  const uploadSelectedFiles = () => {
    setLoading(false);
    const files = uploadDetails?.filesSelected;
    if (!files || files.length === 0) return;

    const totalFiles = files.length;
    let uploadedFilesCount = 0;

    // Publish the run to redux so the app-wide floating widget can keep
    // showing progress even after this page (File Explorer) unmounts.
    dispatch({
      type: Actions.SET_UPLOAD_PROGRESS,
      data: {
        active: true,
        completed: false,
        minimized: false,
        uploaded: 0,
        total: totalFiles,
        returnPath: location.pathname,
      },
    });

    const progress = () => {
      setValue((uploadedFilesCount / totalFiles) * 100);
      dispatch({
        type: Actions.SET_UPLOAD_PROGRESS,
        data: { uploaded: uploadedFilesCount, total: totalFiles },
      });
    };

    const finalizeUpload = () => {
      // Mark the global widget complete (kept until the user dismisses it).
      dispatch({
        type: Actions.SET_UPLOAD_PROGRESS,
        data: { completed: true, uploaded: totalFiles, total: totalFiles },
      });

      setTimeout(() => {
        flushStateVariables();
      }, 2000);

      getStore().dispatch({
        type: Actions.API_GET_SELECTED_SITE_DETAILS,
        data: { siteId: siteId },
        meta: {
          onSuccess: (data) => {
            getStore().dispatch({
              type: Actions.API_GET_SITE_FILES,
              data: {
                siteId: siteId,
                path: path,
                stagingDomainName:
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : data?.siteName,
              },
            });
            const selectedEnvData = data.stagingDomainsList.find(
              (list) =>
                list.environment ===
                (selectedDomain?.environment === "STAGING"
                  ? "STAGING"
                  : "LIVE"),
            );
            getStore().dispatch({
              type: Actions.SET_SELECTED_DOMAIN,
              data: selectedEnvData,
            });
          },
          onError: () => {},
        },
      });
    };

    // Fan every file out through a fixed pool of MAX_CONCURRENT_UPLOADS workers.
    // The backend now creates directories idempotently (mkdir -p) and applies
    // permissions best-effort, so concurrent uploads racing to create the same
    // folder are safe — no sequential "pioneer" pre-pass is needed.
    let activeUploads = 0;
    let currentIndex = 0;

    const uploadNext = () => {
      if (currentIndex >= files.length) {
        if (activeUploads === 0) finalizeUpload();
        return;
      }
      const file = files[currentIndex++];
      activeUploads++;
      uploadFile(file)
        .then(() => {
          uploadedFilesCount++;
          progress();
        })
        .catch((error) => {
          console.error(`Error uploading file: ${file?.name}`, error);
        })
        .finally(() => {
          activeUploads--;
          uploadNext();
        });
    };

    if (files.length === 0) {
      finalizeUpload();
      return;
    }
    while (activeUploads < MAX_CONCURRENT_UPLOADS && currentIndex < files.length) {
      uploadNext();
    }
  };

  const uploadFile = async (file, retries = 0) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      // react-dropzone (v14) exposes the in-folder path on `file.path`; native
      // directory inputs use `webkitRelativePath`. Fall back across all of them
      // so nested files keep their folder structure instead of collapsing to the
      // root (which silently overwrites same-named files across subfolders).
      let relativePath =
        file.relativePath || file.path || file.webkitRelativePath || "";
      // Normalize leading "./" or "/" that dropzone/native inputs may prepend.
      relativePath = relativePath.replace(/^\.?\//, "");
      const parts = relativePath.split("/");
      parts.pop(); // drop the file name, keep only the directory segments
      const directoryPath = parts.length ? parts.join("/") + "/" : "";
      const fullPath = path + directoryPath;

      formData.append("path", fullPath);
      formData.append("siteId", siteData?.siteId);
      formData.append(
        "stagingDomainName",
        selectedDomain?.environment === "STAGING"
          ? selectedDomain.domainName
          : sites?.siteName,
      );

      const upload = async (retryCount) => {
        try {
          setLoading(true);
          await axios.post(
            `${process.env.REACT_APP_BACK_END_API_BASE_URL}/fileExplorer/uploadFileWithPermission`,
            formData,
            getAuthorizationHeader(),
          );
        } catch (error) {
          const status = error?.response?.status;
          // Retry transient failures: network/no-response, 5xx (pod overload),
          // and 403/429 (the site's WAF rate-limits bulk uploads with a 403 —
          // those recover once the request rate drops). Other 4xx won't succeed
          // on retry, so don't waste attempts on them.
          const retriable =
            !status || status >= 500 || status === 429 || status === 403;
          if (retriable && retryCount < 5) {
            // Exponential backoff lets the pod / WAF rate-window recover instead
            // of hammering it: ~0.5s, 1s, 2s, 4s, 8s.
            const delay = 500 * 2 ** retryCount;
            await new Promise((resolve) => setTimeout(resolve, delay));
            console.log(
              `Retrying upload for ${file?.name}, attempt ${retryCount + 1}`,
            );
            await upload(retryCount + 1);
          } else {
            console.error(
              `Failed to upload ${file?.name} after 6 attempts:`,
              "status:",
              error?.response?.status,
              "response:",
              error?.response?.data,
              "path:",
              fullPath,
              error,
            );
            throw error;
          }
        }
      };

      await upload(retries);
    } catch (error) {
      console.error("Upload process failed:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // NOTE: the old `workerPool` uploader was removed; all uploads go through
  // uploadSelectedFiles(), a single MAX_CONCURRENT_UPLOADS-wide worker pool.
  // Concurrent same-folder creation is safe because the backend now creates
  // directories idempotently and sets permissions best-effort.

  // When an upload is running and not minimised, keep the popup open (e.g. so
  // "Expand" from the global widget re-navigates here and reveals the modal).
  useEffect(() => {
    if (uploadProgress?.active && !uploadProgress?.minimized) {
      setUploadPopup(true);
    }
  }, [uploadProgress?.active, uploadProgress?.minimized]);

  // Leaving the File Explorer mid-upload hands off to the global widget by
  // forcing the minimised state (a ref keeps the latest value for cleanup).
  const uploadActiveRef = React.useRef(false);
  useEffect(() => {
    uploadActiveRef.current = uploadProgress?.active;
  }, [uploadProgress?.active]);
  useEffect(() => {
    return () => {
      if (uploadActiveRef.current) {
        getStore().dispatch({
          type: Actions.SET_UPLOAD_PROGRESS,
          data: { minimized: true },
        });
      }
    };
  }, []);

  const delFileAPI = (key) => {
    getStore().dispatch({
      type: Actions.API_DELETE_SITE_FILE,
      data: {
        siteId: siteData.siteId,
        key: path + key,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData.siteName,
      },
      meta: {
        onSuccess: () => {
          ActivatePopup("success-del");
          getStore().dispatch({
            type: Actions.API_GET_SITE_FILES,
            data: {
              siteId: siteData?.siteId,
              path: path,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData?.siteName,
            },
          });
        },
        onError: () => {
          ActivatePopup("error");
        },
      },
    });
  };

  const fileDownload = (key) => {
    ActivatePopup("loading");
    getStore().dispatch({
      type: Actions.API_DOWNLOAD_SITE_FILE,
      data: {
        key: path + key,
        siteId: siteData?.siteId,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
      },
      meta: {
        onSuccess: (data) => {
          window.location.href = data;
          ActivatePopup("success");
        },
        onError: (error) => {
          console.error("File download failed:", error);
          ActivatePopup("error");
        },
      },
    });
  };

  const folderDownload = (key) => {
    ActivatePopup("loading");
    getStore().dispatch({
      type: Actions.API_DOWNLOAD_SITE_FOLDER,
      data: {
        key: path + key,
        siteId: siteData?.siteId,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
      },
      meta: {
        onSuccess: (data) => {
          window.location.href = data;
          ActivatePopup("success");
        },
        onError: (error) => {
          console.error("Folder download failed:", error);
          ActivatePopup("error");
        },
      },
    });
  };

  const handleHomeClick = () => {
    setPathAttributes([]);
    openFolder("/");
  };

  const rows = [
    ...siteData?.folders?.map((folder) => ({
      name: (
        <Grid2
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleSelected(folder?.name, null);
          }}
        >
          <FolderOutlinedIcon
            style={{ marginRight: "5px", marginBottom: "-6px" }}
          />
          {folder.name}
        </Grid2>
      ),

      // created: folder.createdAt,
      download: () => folderDownload(folder?.name),
      delete: () => ActivatePopup("confirm-deletefile", folder?.name),
    })),
    ...siteData?.files?.map((file) => ({
      name: (
        <Grid2
          style={{ cursor: "pointer" }}
          onClick={() => handleSelected(null, file?.name)}
        >
          <DescriptionOutlinedIcon
            style={{ marginRight: "5px", marginBottom: "-6px" }}
          />
          {file.name}
        </Grid2>
      ),
      size: formatFileSizeCaps(file.size),
      created:
        organizationsInfo?.country === "USA" || userDetails === "USA"
          ? formatUsTimestamp(file.createdAt)
          : file.createdAt,
      download: () => fileDownload(file?.name),
      delete: () => ActivatePopup("confirm-deletefile", file?.name),
    })),
  ];

  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.header}>File Explorer</Grid2>
        {siteData.siteName && (
          <SiteHeaderCard
            name={
              selectedDomain?.environment === "STAGING"
                ? selectedDomain.domainName
                : siteData.siteName
            }
            domain={
              livedom?.length > 0 && selectedDomain?.environment === "LIVE"
                ? livedom
                : (selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData.siteName) +
                  "." +
                  process.env.REACT_APP_TEMP_DOMAIN
            }
            development={isStaging}
            production={getStagingEnv(siteData.staging, STAGING.LIVE)}
            phpClick={() => adminApi("php")}
            wpClick={() =>
              adminApi(
                "wp",
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData.siteName,
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : livedom?.length > 0
                    ? livedom
                    : null,
                selectedDomain?.environment === "STAGING" ? true : false,
              )
            }
            domainClick={() =>
              adminApi(
                "domain",
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData.siteName,
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : livedom?.length > 0
                    ? livedom
                    : null,
                selectedDomain?.environment === "STAGING" ? true : false,
              )
            }
            siteId={siteData.siteId}
            orgId={orgId}
            image={siteData.imagePath ? siteData.imagePath : null}
            orgInfo={organizationsInfo}
            addOnWaf={siteData.wafStatus}
            addOnPerformanceSite={siteData.performanceSite}
          />
        )}

        <FileTable
          rows={rows}
          upload={"Upload Files"}
          uploadClick={() => setUploadPopup(true)}
          handleHomeClick={() => {
            handleHomeClick();
          }}
          openPath={(index) => {
            openPath(index);
          }}
          pathAttributes={pathAttributes}
          setItem={() => setPathAttributes(selectedFolder?.folderName)}
          sites={sites}
        />
      </Grid2>

      <UploadPopup
        uploadPopup={uploadPopup}
        setUploadPopup={setUploadPopup}
        uploadDetails={uploadDetails}
        setUploadDetails={setUploadDetails}
        uploadSelectedFiles={uploadSelectedFiles}
        flushStateVariables={flushStateVariables}
        loading={loading}
        value={value}
        total={uploadDetails?.filesSelected?.length}
        close={close}
        setClose={setClose}
      />

      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}
